import { PrivateRoute } from "@/common/components/PrivateRoute";
import { PublicRoute } from "@/common/components/PublicRoute";
// import ScrollToTop from "@/common/components/ScrollToTop";
import { ForgotPasswordForm } from "@/modules/Auth/pages/ForgotPasswordForm";
import { LoginForm } from "@/modules/Auth/pages/LoginForm";
import { RegisterForm } from "@/modules/Auth/pages/RegisterForm";
import { ResetPasswordForm } from "@/modules/Auth/pages/ResetPasswordForm";
import { HomePage } from "@/modules/Home/pages/HomePage";
import PropertyPage from "@/modules/Properties/pages/PropertyPage";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

export const AppRouter = () => {
  return (
    <BrowserRouter>
      {/* <ScrollToTop /> */}
      <Routes>
        <Route
          path="/auth/login"
          element={
            <PublicRoute>
              <LoginForm />
            </PublicRoute>
          }
        />
        <Route
          path="/auth/register"
          element={
            <PublicRoute>
              <RegisterForm />
            </PublicRoute>
          }
        />
        <Route
          path="/auth/forgot-password"
          element={
            <PublicRoute>
              <ForgotPasswordForm />
            </PublicRoute>
          }
        />
        <Route
          path="/auth/reset-password"
          element={
            <PublicRoute>
              <ResetPasswordForm />
            </PublicRoute>
          }
        />
        <Route
          path="/home/*"
          element={
            <PrivateRoute>
              <HomePage />
            </PrivateRoute>
          }
        />

        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </BrowserRouter>
  );
};
